import { ExternalLink, ShieldCheck } from "lucide-react";
import MapleLeaf from "@/components/MapleLeaf";

export default function PoweredByStrip() {
  return (
    <section className="border-y border-slate-100 bg-[#FAF6EE]" data-testid="powered-by-strip">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-4 text-center md:text-left">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-white border border-red-100 grid place-items-center shadow-sm">
            <MapleLeaf className="w-5 h-5 text-[#D52B1E]" />
          </div>
          <div>
            <p className="text-[11px] font-bold text-slate-500 uppercase tracking-widest">Powered by</p>
            <p className="font-display font-extrabold text-slate-900 leading-tight">
              Teach Me Online Inc.
              <span className="ml-2 text-xs font-semibold text-slate-500">· Canadian company</span>
            </p>
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-3 md:gap-5 text-xs">
          <span className="inline-flex items-center gap-1.5 text-slate-600">
            <ShieldCheck className="w-3.5 h-3.5 text-emerald-600" />
            Trusted Canadian education initiative
          </span>
          <a
            href="https://teacher4me.ca"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="powered-by-teacher4me-link"
            className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-white border border-slate-200 hover:border-[#D52B1E] hover:text-[#D52B1E] text-slate-800 font-semibold text-xs transition-colors"
          >
            Visit teacher4me.ca <ExternalLink className="w-3.5 h-3.5" />
          </a>
        </div>
      </div>
    </section>
  );
}
